<template lang="pug">
  .presence-list(v-if="shift.shift_times.length > 0 || shift.can_add")
    div
      strong {{ shift.shift_type }}
      |  ({{ [shift.start, "HH:mm:ss"] | moment('HH:mm') }} Uhr)
    presence-entry(v-for="entry in shift.shift_times" :shift-time="entry"
      :key="entry.id" @refresh="$emit('refresh')" :user="user")
    vue-autosuggest.addButton(:suggestions="filteredOptions" :input-props="inputProps"
       v-if="shift.can_add && user.can_record_shift_times" ref="addEmployee" v-model="query"
      :class="{'confirmationPending': selected}"
      @input="onInputChange"
      @selected="onSelected"
      @focus="getEmployeeList()"
      @click="clickHandler"
      @closed="clearLetters()"
      :getSuggestionValue="getValue"
    )
      template(slot-scope="{suggestion}")
        span(v-html="bolden(query, suggestion.item.short_name)")

    span(v-if="selected")
      button(@click="confirmSelection()") JA
      button(@click="clear()") Abbrechen
</template>

<script>
// @blur="adding=false"
// open on select - focus un load
// https://codesandbox.io/s/qqqzqryq4w?file=/src/components/HelloWorld.vue
import { VueAutosuggest } from 'vue-autosuggest'

export default {
  name: 'presence-list',
  props: ['shift', 'user'],
  components: {
    VueAutosuggest
  },
  data () {
    return {
      selected: '',
      query: '',
      loginToken: this.$localStorage.get('loginToken'),
      options: [{
        data: []
      }],
      filteredOptions: [],
      inputProps: {
        id: 'autosuggest__input',
        input: this.onInputChange,
        placeholder: '+'
      }
    }
  },
  methods: {
    clickHandler () {
      this.loading = false
    },
    bolden (text, suggestion) {
      const regex = new RegExp('(' + text + ')', 'gi')

      return suggestion.replace(regex, '<b>$1</b>')
    },
    getEmployeeList () {
      this.$http.get('/search-free-employees/?shift=' + this.shift.id)
          .set({Authorization: 'jwt ' + this.loginToken})
          .then(res => {
            this.options = res.body
            this.filteredOptions = res.body
          })
          .catch((err, data) => {
            console.log(err)
          })
    },
    getValue (option) {
      return option.item.short_name
    },
    clear () {
      this.$refs.addEmployee.internalValue = ''
      this.selected = undefined
    },
    clearLetters () {
      if (!this.selected && this.$refs.addEmployee) {
        this.clear()
      }
    },
    onSelected (option) {
      this.selected = option.item
      this.query = this.selected.short_name
    },
    confirmSelection () {
      this.$http.post('/add-employee-to-shift/', {user: this.selected, shift: this.shift.id})
        .set({Authorization: 'jwt ' + this.loginToken})
        .then(res => {
          this.$emit('refresh')
          this.getEmployeeList()
          this.clear()
        })
        .catch((err, data) => {
          console.log(err)
        })
    },
    onInputChange (text) {
      if (text === '' || text === undefined) {
        return
      }

      /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
      const filteredData = this.options[0].data.filter(item => {
        return item.short_name.toLowerCase().indexOf(text.toLowerCase()) > -1
      }).slice(0, this.limit)

      this.filteredOptions = [{
        data: filteredData
      }]
    }
  },
  created () {
  },
  computed: {
  }
}
</script>


<style lang="sass">
.presence-list
  padding: 16px
span button
  margin-left: 15px

.addButton
  width: 50px
  display: inline-block
  &.confirmationPending
    width: 170px


// auto suggestion
#autosuggest__input
  outline: none
  position: relative
  display: block
  border: 1px solid #d7d6d6
  padding: 5px 10px
  width: 30px
  box-sizing: border-box
  -webkit-box-sizing: border-box
  -moz-box-sizing: border-box
  border-radius: 2px
  cursor: pointer
  // transition: all 0.2s ease-in-out

.confirmationPending #autosuggest__input, #autosuggest__input:focus
  width: 170px
  padding: 10px
  border-color: #616161


#autosuggest__input.autosuggest__input-open
  border-bottom-left-radius: 0
  border-bottom-right-radius: 0


.autosuggest__results-container
  position: relative
  width: 170px


.autosuggest__results
  font-weight: 300
  margin: 0
  position: absolute
  z-index: 10000001
  width: 100%
  border: 1px solid #e0e0e0
  border-bottom-left-radius: 4px
  border-bottom-right-radius: 4px
  background: white
  padding: 0


.autosuggest__results ul
  list-style: none
  padding-left: 0
  margin: 0
  max-height: 200px
  overflow-x: auto


.autosuggest__results .autosuggest__results-item
  cursor: pointer
  padding: 15px


#autosuggest ul:nth-child(1) > .autosuggest__results_title
  border-top: none


.autosuggest__results .autosuggest__results_title
  color: gray
  font-size: 11px
  margin-left: 0
  padding: 15px 13px 5px
  border-top: 1px solid lightgray


.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results
  .autosuggest__results-item.autosuggest__results-item--highlighted
    background-color: #F6F6F6


</style>



// WEBPACK FOOTER //
// PresenceList.vue?71cdb45c